//https://tanstack.com/query/v4/docs/react/devtools#devtools-in-production
import React, { Suspense } from 'react';

import Portal from 'utility/Bind/Portal/Portal';
import { lazyRetry } from 'utility/Lazy/Retry';

const ReactQueryDevtools = React.lazy(() =>
    lazyRetry(() =>
        import('@tanstack/react-query-devtools').then((d) => ({
            default: d.ReactQueryDevtools,
        }))
    )
);

const ReactQueryDevtoolsProduction = React.lazy(() =>
    lazyRetry(() =>
        import('@tanstack/react-query-devtools/build/lib/index.prod.js').then(
            (d) => ({
                default: d.ReactQueryDevtools,
            })
        )
    )
);

interface MyWindow extends Window {
    toggleDevtools(): void;
}

declare const window: MyWindow;

const portalId = 'portal-react-query-dev-tools';

export default function App() {
    const [showDevtools, setShowDevtools] = React.useState(false);
    React.useEffect(() => {
        window.toggleDevtools = () => setShowDevtools((old) => !old);
        setTimeout(() => {
            const portalContainer = document.getElementById(portalId);
            if (
                portalContainer &&
                portalContainer.isConnected &&
                portalContainer.innerHTML.trim() === ''
            ) {
                //toggle for production build if container is available
                setShowDevtools(true);
            }
        }, 1000);
    }, []);

    return (
        <Portal root={`#${portalId}`}>
            <Suspense fallback={<></>}>
                <ReactQueryDevtools initialIsOpen />
                {showDevtools && (
                    <Suspense fallback={null}>
                        <ReactQueryDevtoolsProduction />
                    </Suspense>
                )}
            </Suspense>
        </Portal>
    );
}
